import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
import debounced from "debounced";
export default class extends ApplicationController {
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    debounced.initialize({ input: { wait: 2000 } });
    debounced.initialize({ keyup: { wait: 2000 } });
  }
  updateView(event){
    if (new Date(event.target.value) > new Date("2001-01-01")) {
      this.stimulate("Frais#update_view", event.currentTarget);
    } else {
      console.log("No date", event.target.value);
    }
  }
  get current_app() {
    return this.data.get("app");
  }
  get note_de_frai_id() {
    return this.data.get("note_de_fraiid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}



 